<div *ngIf="isLoading" class="overlay-loader">
  <div class="spinner"></div>
</div>

<ng-container *ngIf="isAuthenticated(); else unauthenticated">
  <app-side-nav-inner-toolbar>
    <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
  </app-side-nav-inner-toolbar>
</ng-container>

<ng-template #unauthenticated>
  <app-unauthenticated-content></app-unauthenticated-content>
</ng-template>


<div style="background-color: #003B5B;">
  <app-footer></app-footer>
</div>
